import { render } from "./BaseCheckbox.vue?vue&type=template&id=423b1511"
import script from "./BaseCheckbox.vue?vue&type=script&lang=js"
export * from "./BaseCheckbox.vue?vue&type=script&lang=js"

import "./BaseCheckbox.vue?vue&type=style&index=0&id=423b1511&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__